import { useEffect, useState } from 'react'

// The visible part of the page (window.visualViewport): its height and how far
// iOS has scrolled the layout viewport under it. Null where the browser has no
// visualViewport. Used to keep sheets above the keyboard (lib/sheetFit.ts).
export function useVisualViewport(enabled = true) {
  const [vv, setVv] = useState<{ height: number; offsetTop: number } | null>(null)
  useEffect(() => {
    const v = window.visualViewport
    if (!enabled || !v) return
    const read = () => setVv({ height: v.height, offsetTop: v.offsetTop })
    read()
    v.addEventListener('resize', read)
    v.addEventListener('scroll', read)
    return () => { v.removeEventListener('resize', read); v.removeEventListener('scroll', read) }
  }, [enabled])
  return vv
}
